import { connect } from 'react-redux';
import { redirectToWebForm } from '../../actions/SubmitSuccessPage';
import SubmitSuccessPage from './SubmitSuccessPage';

function mapsStateToProps(state) {
	return {};
}

function mapsDispatchToProps(dispatch) {
	return {
		redirectToWebForm() {
			dispatch(redirectToWebForm());
		}
	};
}

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(SubmitSuccessPage);
